<style lang="less" scoped>
    .data-export {
        .button-group {
            margin: 10px 0;
        }
        /deep/ .ivu-table td {
            height: 0px;
        }
        /deep/ .display-none {
            height: 0 !important;
            margin: 0;
            padding: 0;
            display: none;
            overflow: hidden;
            // opacity: 0;
            visibility: hidden;
            /deep/ .ivu-table-column-center {
                // display: none;
                height: 0 !important;
                overflow: hidden;
                margin: 0;
                padding: 0;
                .ivu-table-cell {
                    // display: none;
                    height: 0 !important;
                    overflow: hidden;
                    margin: 0;
                    padding: 0;
                    /deep/span {
                        //  display: none;
                        height: 0 !important;
                        overflow: hidden;
                        margin: 0;
                        padding: 0;
                    }
                }
            }
        }
    }
</style>
<template>
  <div class="data-export">
    <Spin
      v-if="loading.getDataExportLoading"
      size="large"
      fix
    />
    <div class="button-group">
      <DatePicker
        v-model="selectedDate"
        :options="dateOptions"
        :clearable="false"
        type="daterange"
        format="yyyy-MM-dd"
        confirm
        placeholder="请选择时间范围"
        style="width: 300px"
        @on-ok="getData"
      />
      <Button 
        style="margin-left:20px"
        type="primary"
        @click="outputExcel"
      >
        导出
      </Button>
    </div>
    <div>
      <p>单位：元</p>
      <Table
        ref="#out-table"
        border
        :columns="columns"
        :data="tableData"
        :span-method="handleSpan"
        :row-class-name="rowClassName"
      />
      <p style="display:inline-block;margin:10px 0px">
        备注：请选择时间范围
      </p>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import { mapActions, mapState } from 'vuex'
  import { NAME_SPACE } from './../constants'
  import { dataExportFields, typeHash } from './data_export_fields'
  import { makeData, assembleData, formattingNumber } from './../utils'
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'

  export default {
    props: {
      rootTeamsHash: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        selectedDate: [new Date(), new Date()],
        levelTwoKey:{},
      }
    },
    computed:{
      columns() {
        const arr = []
        let startTime = moment(this.selectedDate[0]).format('YYYY-MM-DD')
        const endTime = moment(this.selectedDate[1]).format('YYYY-MM-DD')
        while (moment(startTime).isBefore(endTime) || startTime === endTime) {
          arr.push(startTime)
          startTime = moment(startTime).add(1, 'days').format('YYYY-MM-DD')
        }
        const columns_date = arr.map(item => {
          let title = moment(item).format('MM-DD').split('-')
          // title = `${title[0]}月${title[1]}日`
          title = `${title[0]}月${title[1]}日`
          return {
            title,
            key: moment(item).format('MM-DD'),
            align:'right',
            minWidth: 120,
            render: (h, { row, index }) => {
              const key = moment(item).format('MM-DD')
              if (index === 0) {
                return <span> {row[key]}</span>
              }
              return <span>{row[key] !== undefined ? formattingNumber(row[key], 1) : '-'}</span>
            },
          }
        })
        return dataExportFields({ teamHash: this.rootTeamsHash }).concat(columns_date)
      },
      ...mapState(NAME_SPACE, {
        loading:'loading',
        dataExportData: 'dataExportData'
      }),
      tableData() {
        return this.handleData(this.dataExportData)
      },
      dateOptions() {
        return {
          disabledDate(date) {
            return moment(moment()).isBefore(moment(date));
          }
        }
      }
    },
    methods: {
      getData() { // 获取数据 
        this.getDataExport({
          start_date: moment(this.selectedDate[0]).format('YYYY-MM-DD'),
          end_date: moment(this.selectedDate[1]).format('YYYY-MM-DD')
        })
      },
      handleData(dataExportData) { // 处理数据
        if (!dataExportData) {
          return []
        }
        this.levelTwoKey = makeData(dataExportData) // 获取项目组
        const title_data = {} // 第一组数据，用于打印占位不显示在页面上
        this.columns.forEach(item => {
          title_data[item.key] = item.title
        })
        return [title_data, ...assembleData(dataExportData, typeHash, this.levelTwoKey)]
      },
      handleSpan({rowIndex, columnIndex }) { // 合并单元格
        if (rowIndex === 0 || columnIndex > 1) {
          return
        }
        if (rowIndex % 2 === 1 && columnIndex === 1) {
          return [2, 1]
        } else if (rowIndex % 2 !== 1 && columnIndex === 1) {
          return [0, 0]
        }
        if (this.tableData[rowIndex - 1].type !== this.tableData[rowIndex].type) {
          let end = rowIndex + 1
          while (this.tableData[end] && this.tableData[rowIndex].type === this.tableData[end].type) {
            end++  
          }
          return [end - rowIndex, 1]
        }
        if (this.tableData[rowIndex - 1].type === this.tableData[rowIndex].type && columnIndex === 0) {
          return [0, 0]
        }
      },
      outputExcel() { // 导出excel
        /* generate workbook object from table */
        const targetTable = this.$refs['#out-table'].$el.getElementsByTagName('table')
        const selectedDate = this.selectedDate
        const wb = XLSX.utils.table_to_book(targetTable[4])
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${moment(selectedDate[0]).format('YYYY-MM-DD')}-${moment(selectedDate[1]).format('YYYY-MM-DD')}销售数据.xlsx`)
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      },
      rowClassName(row, index) {
        if (index === 0) {
          return 'display-none'
        }
        return '';
      },
      ...mapActions(NAME_SPACE, [
        'getDataExport',
      ]),
    }
  }
</script>
